import React from "react";
import MpcTabButtonShimmer from "../common/shimmer/MpcTabButtonShimmer";
import PatientListPanelShimmer from "../common/shimmer/PatientListPanelShimmer";

const TeamPerformanceShimmer = () => (
  <div className="mpc-tabs-shell mpc-team-performance-shell mpc-staff-performance-shimmer" aria-busy="true" aria-label="Loading team performance report">
    <div className="mpc-tab-panel">
      <div className="mpc-tab-panel-body">
        <div className="mpc-panel-intro mpc-shimmer-block" style={{ minHeight: 72, marginBottom: 16 }} />
            <div className="mpc-team-insight-banner mpc-shimmer-block" style={{ minHeight: 52, marginBottom: 16 }} />
            <div className="mpc-team-stat-row">
          <div className="mpc-team-stat-card mpc-shimmer-block" style={{ minHeight: 88 }} />
          <div className="mpc-team-stat-card mpc-shimmer-block" style={{ minHeight: 88 }} />
          <div className="mpc-team-stat-card mpc-shimmer-block" style={{ minHeight: 88 }} />
        </div>
        <PatientListPanelShimmer rowCount={8} embedded />
      </div>
    </div>
  </div>
);

const MonthlyPhoneConsultationShimmer = ({ variant = "patientOutreach" }) => {
  if (variant === "teamPerformance") {
    return (
      <div className="mpr-shimmer-wrap mpc-shimmer-wrap" aria-busy="true" aria-label="Loading report">
        <div className="mpc-report-subnav mpc-report-subnav--shimmer mpc-shimmer-block" />
        <TeamPerformanceShimmer />
      </div>
    );
  }

  return (
  <div className="mpr-shimmer-wrap mpc-shimmer-wrap" aria-busy="true" aria-label="Loading report">
    <div className="mpc-report-subnav mpc-report-subnav--shimmer mpc-shimmer-block" />

    <div className="mpc-tabs-shell mpr-shimmer-tabs-shell">
      <div className="mpc-tab-bar mpr-shimmer-tab-bar">
        <div className="mpc-tab-bar-tabs">
          <MpcTabButtonShimmer />
          <MpcTabButtonShimmer />
        </div>
        <div className="mpc-tab-bar-total mpc-shimmer-block mpc-shimmer-total-patient" />
      </div>
      <div className="mpc-tab-panel">
        <PatientListPanelShimmer rowCount={6} embedded withFailedColumn />
      </div>
    </div>
  </div>
  );
};

export default MonthlyPhoneConsultationShimmer;
